import FormControlLabel from '@mui/material/FormControlLabel';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import IconButton from 'Components/Buttons/IconButton';
import React from 'react';

const StyledPaper = styled(Paper)({
    borderRadius: 0
});

const Toolbar = styled('div')({
    backgroundColor: '#EEEEEE',
    padding: 10
});

const Header = styled(Typography)({
    backgroundColor: '#EEEEEE',
    fontSize: '80%',
    fontWeight: 'bold',
    padding: '15px 0 15px 25px'
});

const HeaderToolbar = styled('div')({
    backgroundColor: '#EEEEEE',
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px 0 25px'
});

const HeaderToolbarText = styled(Typography)({
    fontSize: '80%',
    fontWeight: 'bold',
    padding: '15px 0'
});

const Details = styled('div')({
    padding: 20,
    paddingTop: 10
});

const SmallFormControlLabel = styled(FormControlLabel)(() => ({
    '& .MuiFormControlLabel-label': {
        fontSize: '0.75rem'
    }
}));

const Component = ({ buttons = [], children, header, realtime, setRealtime }) => {
    const mergedHeader = header && buttons.length > 0 && !setRealtime;

    return (
        <StyledPaper>
            {mergedHeader ? (
                <HeaderToolbar>
                    <HeaderToolbarText component="h6" variant="h6">{header}</HeaderToolbarText>
                    {buttons.map(button => <IconButton key={button.icon} {...button}/>)}
                </HeaderToolbar>
            ) : (
                <>
                    {(buttons.length > 0 || setRealtime) && (
                        <Toolbar>
                            {setRealtime ? (
                                <SmallFormControlLabel
                                    control={
                                        <Switch
                                            checked={realtime}
                                            name="checked"
                                            onChange={event => setRealtime(event.target.checked)}
                                            size="small"
                                        />
                                    }
                                    label="Pool Data"
                                />
                            ) : (
                                buttons.map(button => <IconButton key={button.icon} {...button}/>)
                            )}
                        </Toolbar>
                    )}
                    {header && <Header component="h6" variant="h6">{header}</Header>}
                </>
            )}
            <Details>{children}</Details>
        </StyledPaper>
    );
};

export default Component;
